import styled from 'styled-components'
import { withOpacity } from '../../helpers'

export default styled.div`
  position: relative;
  display: inline-block;
  text-align: left;

  .pill {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 18px;
    border: 2px solid ${ ({ theme }) => theme.colors.greyDark };
    border-radius: 30px;
    background-color: ${ ({ theme }) => theme.colors.transparent };
    color: ${ ({ theme }) => withOpacity(theme.colors.white, 80) };
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      // background-color: ${ ({ theme }) => theme.colors.accentLight };
    }

    .globe {
      width: 20px;
      height: 20px;
    }

    .chevron {
      width: 12px;
      height: 12px;
      transition: transform 0.2s ease;

      &.open {
        transform: rotate(180deg);
      }
    }
  }

  .options {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 20;
    min-width: 100%;
    max-height: 320px;
    overflow-y: auto;
    padding: 6px 0;
    border-radius: 16px;
    background-color: ${ ({ theme }) => theme.colors.white };
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);

    .option {
      display: flex;
      align-items: center;
      gap: 10px;
      width: 100%;
      padding: 10px 18px;
      border: none;
      background-color: transparent;
      color: ${ ({ theme }) => theme.colors.black };
      font-family: ${ ({ theme }) => theme.fontFamily };
      font-size: 16px;
      line-height: 20px;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        background-color: ${ ({ theme }) => theme.colors.accentLight };
      }

      &.selected {
        color: ${ ({ theme }) => theme.colors.accentDark };
        font-weight: 600;
      }

      .flag {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        object-fit: cover;
      }

      .check {
        width: 14px;
        margin-left: auto;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .pill {
      padding: 8px 14px;
      font-size: 14px;
    }
  }
`
